import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import indexGenerics, {Params as BaseParams} from '../generics/index';

import TextFrame from '../../../domain/entities/TextFrame';
import PaginatedResult from '../../../domain/results/PaginatedResult';

import NetTextFramesRepository from '../../../data/repositories/NetTextFramesRepository';

const types = {
  failure: Types.IndexTextFramesFailure,
  request: Types.IndexTextFramesRequest,
  success: Types.IndexTextFramesSuccess,
};

export interface Params extends BaseParams {}

export default function action(
  params: Params,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<PaginatedResult<TextFrame>> {
  return indexGenerics(new NetTextFramesRepository(), types, params);
}
